'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_USER_PROFILE = exports.UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
var UPDATE_MODULE = exports.UPDATE_MODULE = 'UPDATE_MODULE';
var INIT_LAYOUT_JSON = exports.INIT_LAYOUT_JSON = 'INIT_LAYOUT_JSON';
var UPDATE_LAYOUT_JSON = exports.UPDATE_LAYOUT_JSON = 'UPDATE_LAYOUT_JSON';
var UPDATE_FIELD_VALUE = exports.UPDATE_FIELD_VALUE = 'UPDATE_FIELD_VALUE';


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/module/actionTypes.js
// module id = 1833
// module chunks = 1137